export const getEvrythngToken = async (shortUrl) => {
	// follow redirect, capture response url
	return new Promise((resolve, reject) => {
		var xhr = new XMLHttpRequest();
		xhr.onreadystatechange = function (e) {
			if (xhr.readyState === 4) {
				if (xhr.status === 200) {
					if (shortUrl !== xhr.responseURL) {
						const matches = xhr.responseURL.match(/token=(.*(&|$))/i);
						const token = matches?.[1]; // grab first capture group (everything after token=)
						if (token) {
							resolve(token);
						} else {
							reject();
						}
					}
				} else {
					reject();
				}
			}
		};
		xhr.open('GET', shortUrl, true);
		xhr.send();
	});
};

export const setEvrythngKey = (key) => {
	window.evrythngToken = new window.evrythng.AccessToken(key);
};
